/**
 * LINE Config API Service
 */
import apiClient from '../axios.js';

export default {
  /**
   * 查詢 LINE 設定列表
   * @param {Object} params - 查詢參數
   * @returns {Promise}
   */
  async list(params = {}) {
    const response = await apiClient.get('/line/config', { params });
    return response;
  },

  /**
   * 查詢 LINE 設定詳情
   * @param {string} id - 設定 ID
   * @returns {Promise}
   */
  async get(id) {
    const response = await apiClient.get(`/line/config/${id}`);
    return response;
  },

  /**
   * 建立 LINE 設定
   * @param {Object} data - 設定資料
   * @returns {Promise}
   */
  async create(data) {
    const response = await apiClient.post('/line/config', data);
    return response;
  },

  /**
   * 更新 LINE 設定
   * @param {string} id - 設定 ID
   * @param {Object} data - 更新資料
   * @returns {Promise}
   */
  async update(id, data) {
    const response = await apiClient.put(`/line/config/${id}`, data);
    return response;
  },

  /**
   * 刪除 LINE 設定
   * @param {string} id - 設定 ID
   * @returns {Promise}
   */
  async delete(id) {
    const response = await apiClient.delete(`/line/config/${id}`);
    return response;
  },

  /**
   * 強制重新取得 OA 統計資料（好友數、封鎖數、付費方案，略過快取）
   * @param {string} id - 設定 ID
   * @returns {Promise}
   */
  async refreshStats(id) {
    const response = await apiClient.post(`/line/config/${id}/refresh-stats`);
    return response;
  }
};
